import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  IconButton
} from 'design-system';
import { EllipsisVertical, LayoutDashboard, Save, Trash2, TrashIcon } from 'lucide-react';

import { ButtonsContainer } from '@/features/dashboard/components/Drawer/components/ButtonsContainer';
import { DASHBOARD_ACTION_BUTTON_WIDTH } from '@/features/dashboard/constants/style';

type EditActionButtonsProps = {
  isPending: boolean;
  isSaveDisabled: boolean;
  onDiscard: () => void;
  onAddApp: () => void;
  onSave: () => void;
  onRemoveAll: () => void;
  onRemoveDashboard: () => void;
};

export const EditActionButtons = ({
  isPending,
  isSaveDisabled,
  onDiscard,
  onAddApp,
  onSave,
  onRemoveAll,
  onRemoveDashboard
}: EditActionButtonsProps) => {
  return (
    <ButtonsContainer>
      <DropdownMenu>
        <DropdownMenuTrigger
          render={
            <IconButton
              disabled={isPending}
              label='More options'
              size='icon-lg'
              variant='ghost'
            />
          }
        >
          <EllipsisVertical aria-hidden='true' />
        </DropdownMenuTrigger>
        <DropdownMenuContent align='end'>
          <DropdownMenuItem onClick={onRemoveAll}>
            <TrashIcon aria-hidden='true' />
            Remove all
          </DropdownMenuItem>
          <DropdownMenuItem
            variant='destructive'
            onClick={onRemoveDashboard}
          >
            <Trash2 aria-hidden='true' />
            Delete dashboard
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <Button
        disabled={isPending}
        size='lg'
        style={{ width: DASHBOARD_ACTION_BUTTON_WIDTH }}
        variant='outline'
        onClick={onDiscard}
      >
        Discard
      </Button>
      <Button
        size='lg'
        style={{ width: DASHBOARD_ACTION_BUTTON_WIDTH }}
        variant='secondary'
        onClick={onAddApp}
      >
        <LayoutDashboard aria-hidden='true' />
        Add app
      </Button>
      <Button
        disabled={isSaveDisabled}
        size='lg'
        style={{ width: DASHBOARD_ACTION_BUTTON_WIDTH }}
        onClick={onSave}
      >
        <Save aria-hidden='true' />
        Save
      </Button>
    </ButtonsContainer>
  );
};
